import React from 'react'
import * as H from 'history'
import Button from 'react-bootstrap/Button'

import { Alert } from 'react-bootstrap'
import { ISupportSpinner } from '../../../shared/Ajax'
import {
  ErrorText, MultiLineField, validateFields, BooleanRadioButtonField, FormItem, Label, Checkbox,
} from '../../../shared/fields'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import { MilestoneReportEditable } from '../EditableTable'
import { Backdrop } from '../../../shared/Backdrop'
import { MilestoneReportModel } from '../../../models/MilestoneReportModel'
import { MilestoneReportController } from '../../../controllers/MilestoneReportController'
import { Columns } from '../../../shared/EditableTable/Model'
import { MilestoneModel } from '../../../models/MilestoneModel'
import initialDataExpenditureMilestoneReport from './ExpenditureConfig'
import { EligibleExpenditureCategoryMilestoneReportModel } from '../../../models/EligibleExpenditureCategoryMilestoneReportModel'
import { Table } from '../../../shared/table'
import { OverseasRepresentativeModel } from '../../../models/OverseasRepresentativeModel'
import { OverseasRepresentativeDetails, OverseasRepresentativeColumns } from './otherTables/OverseasRepresentative/OverseasRepresentativeDetails'
import { MilestoneConsultantModel } from '../../../models/MilestoneConsultantModel'
import { MilestoneConsultantDetails, MilestoneConsultantColumns } from './otherTables/MilestoneConsultant/MilestoneConsultantDetails'
import { EligibleExpenditureCategory, TierComplianceRequirements } from '../../../shared/Utility'
import { TierRequirement } from '../../../models/TierRequirement'
import EMDGAccordion from '../../../shared/EMDGAccordion'

export const yesNoDataSource = [{ value: false, label: 'No' }, { value: true, label: 'Yes' }]

export interface Props {
    history: H.History
    model: MilestoneReportModel
    preview?: boolean
    onChange: { (changes: Partial<MilestoneModel>, callback?: { (): any }): any }
}

export interface State {
    loading: boolean,
    isExpenditureTableEmpty: boolean
    noExpenditureErrorMessage : string
    isOverseasRepresentativeSelected: boolean
    isConsultantSelected: boolean
    tierRequirementsSelected: boolean[]
    isTierComplianceEmpty: boolean
    isOtherTierCompliance: boolean
    otherTierComplianceComment: string
}

export class Expenditure extends React.Component<Props, State> implements
    ISupportSpinner {
  ajax: MilestoneReportController
  editable: MilestoneReportEditable
  invalidTierComplianceError: HTMLDivElement
  invalidExpenditureError: HTMLDivElement
  refInvalidNoExpensesRules: HTMLDivElement
  promotionalActivityUndertaken: MultiLineField
  tierComplianceComment: MultiLineField
  marketingProductOverseas: MultiLineField
  overseasRepresentatives: Table<OverseasRepresentativeModel>
  milestoneConsultants: Table<MilestoneConsultantModel>
  consultantsDescription: MultiLineField
  overseasDescription: MultiLineField
  shortTripForeignCountry: MultiLineField
  solicitingForForeignCountry: MultiLineField
  freeSamplesSelected: MultiLineField
  shortTripAustralia: MultiLineField
  promotionalLiterature: MultiLineField
  intellectualPropertyRights: MultiLineField
  training: MultiLineField
  foreignBuyer: MultiLineField
  canClaimConsultantCost: BooleanRadioButtonField
  canClaimOverseasRepresentativeCost: BooleanRadioButtonField

  constructor(props: Props) {
    super(props)
    this.ajax = new MilestoneReportController()

    const { model } = props
    const tierRequirementsSelected = new Array(model.tierComplianceConfig.length).fill(false)
    let isOtherTierCompliance = false
    let otherTierComplianceComment = ''
    const isTierComplianceEmpty = true

    if (model.milestoneModel?.tierRequirements?.length > 0) {
      model.milestoneModel.tierRequirements.map((r) => {
        const position = model.tierComplianceConfig.map((d) => d.id).indexOf(r.crmTierRequirementID)
        if (position > -1) {
          tierRequirementsSelected[position] = true
          if (model.tierComplianceConfig[position].id === TierComplianceRequirements.OthersCrmId) {
            isOtherTierCompliance = true
            otherTierComplianceComment = r.description
          }
        }
      })
    }

    this.state = {
      loading: false,
      isExpenditureTableEmpty: false,
      noExpenditureErrorMessage: '', // default to NoError, else display it;
      isOverseasRepresentativeSelected: props.model.milestoneModel.isOverseasRepresentativeSelected ? props.model.milestoneModel.isOverseasRepresentativeSelected : false,
      isConsultantSelected: props.model.milestoneModel.isConsultantSelected ? props.model.milestoneModel.isConsultantSelected : false,
      isTierComplianceEmpty: false,
      isOtherTierCompliance,
      otherTierComplianceComment,
      tierRequirementsSelected,
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { model, onChange } = this.props

    if (this.isExpenseCategorySelected(prevProps.model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.Consultant).isPresent
            !== this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.Consultant).isPresent) {
      onChange({ isConsultantSelected: this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.Consultant).isPresent })
    }

    if (this.isExpenseCategorySelected(prevProps.model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.OverseasRep).isPresent
            !== this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.OverseasRep).isPresent) {
      onChange({ isOverseasRepresentativeSelected: this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.OverseasRep).isPresent })
    }
  }

  isTierComplianceOk = () => {
    const retVal = !this.state.tierRequirementsSelected.some((x) => x === true)
    this.setState({ isTierComplianceEmpty: retVal })
    return retVal
  }

  next = () => {
    validateFields(
      (res) => {
        if (this.isTierComplianceOk()) {
          this.invalidTierComplianceError.focus()
          return
        }

        if (!this.isValidExpenditureTable()) {
          this.invalidExpenditureError.focus()
          return
        }

        // new May/2023
        if (!this.areNoExpenseRulesOk()) {
          this.refInvalidNoExpensesRules.focus()
          return
        }

        if (res) {
          const { model, history, onChange } = this.props
          this.ajax.saveMilestoneReport(
            this,
            model.milestoneModel,
            (d) => {
              onChange({ ...model.milestoneModel, ...d })
              history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/exportEarning`)
            },
          )
        }
      },
      this.promotionalActivityUndertaken,
      this.tierComplianceComment,
      this.marketingProductOverseas,
      this.overseasRepresentatives,
      this.milestoneConsultants,
      this.consultantsDescription,
      this.overseasDescription,
      this.shortTripForeignCountry,
      this.solicitingForForeignCountry,
      this.freeSamplesSelected,
      this.shortTripAustralia,
      this.promotionalLiterature,
      this.intellectualPropertyRights,
      this.training,
      this.foreignBuyer,
    )
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }


  isExpenseCategorySelected = (eligibleExpenditureCategories: EligibleExpenditureCategoryMilestoneReportModel[], expenseCategory: String): {
            isPresent: boolean,
            index: number
        } => {
    const { model } = this.props

    let index = -1
    // -- no idea why this variable is called 'overseasCrmId' ?!
    const overseasCrmId = model.eligibleExpenditureCategoryList.filter(
      (eligibleExpenditureCategory) => {
        if (eligibleExpenditureCategory.label === expenseCategory) {
          return true
        }
        return false
      },
    )
    const asd = eligibleExpenditureCategories.some((x, i) => {
      if (x.eligibleExpenditureCategoryCrmID === overseasCrmId[0].value) return (index = i)
    })

    return {
      isPresent: index !== -1,
      index,
    }
  }

  isValidExpenditureTable(): boolean {
    const { model } = this.props
    if (model.milestoneModel.eligibleExpenditureCategories.length > 0) {
      const nonEmptyEligibleExpenditureCategories = model.milestoneModel.eligibleExpenditureCategories.filter(
        (eligibleExpenditureCategory) => {
          if (Object.keys(eligibleExpenditureCategory).length === 0) {
            return false
          } if (
            (!(eligibleExpenditureCategory.hasOwnProperty('eligibleExpenditureCategoryCrmID'))
                            || !(eligibleExpenditureCategory.hasOwnProperty('totalEligibleExpenditure'))
                            || (!(eligibleExpenditureCategory.hasOwnProperty('grantSoughtAmount')))
                            || (!(eligibleExpenditureCategory.hasOwnProperty('granteeContributionAmount'))))
                        || ((eligibleExpenditureCategory.eligibleExpenditureCategoryCrmID === undefined)
                            || (eligibleExpenditureCategory.totalEligibleExpenditure === undefined)
                            || (eligibleExpenditureCategory.grantSoughtAmount === undefined)
                            || (eligibleExpenditureCategory.granteeContributionAmount === undefined))
                        || ((eligibleExpenditureCategory.totalEligibleExpenditure === null)
                            || (eligibleExpenditureCategory.grantSoughtAmount === null)
                            || (eligibleExpenditureCategory.granteeContributionAmount === null))
                        || ((eligibleExpenditureCategory.totalEligibleExpenditure.toString() === '')
                            || (eligibleExpenditureCategory.grantSoughtAmount.toString() === '')
                            || (eligibleExpenditureCategory.granteeContributionAmount.toString() === ''))) {
            return false
          }
          return true
        },
      )
      if (nonEmptyEligibleExpenditureCategories.length
                !== model.milestoneModel.eligibleExpenditureCategories.length) {
        this.setState({ isExpenditureTableEmpty: true })
        return false
      }
      this.setState({ isExpenditureTableEmpty: false })
      return true
    }
    this.setState({ isExpenditureTableEmpty: true })
    return false
  }

  // May/2023: new Category for table + business rules;
  areNoExpenseRulesOk(): boolean {
    const NO_EXP_ERRMSG_MUTUALLY_EXCLUSIVE = 'No other eligible expense categories can be selected if No expenditure is selected'
    const NO_EXP_ERRMSG_ZERO_ONLY = 'Value/s of zero (0) must be entered for No expenditure category'

    const { model } = this.props
    const tableRowsArr = model.milestoneModel.eligibleExpenditureCategories

    const isNoExpenditureSelected = this.isExpenseCategorySelected(tableRowsArr, 'No expenditure')
    /* { isPresent: true, index: 3 } => means it's selected on the 4th row of the table
         * { isPresent: false, index: -1 } => means NOT selected;
         */
    if (isNoExpenditureSelected.isPresent) {
      // check that it is the ONLY row selected. i.e. mutually exclusive
      if (tableRowsArr.length === 1) { //
        // further checks, are all entries 0?
        if (+tableRowsArr[0].totalEligibleExpenditure === 0
                    && +tableRowsArr[0].grantSoughtAmount === 0
                    && +tableRowsArr[0].granteeContributionAmount === 0) {
          this.setState({ noExpenditureErrorMessage: '' })
          return true
        }
        this.setState({ noExpenditureErrorMessage: NO_EXP_ERRMSG_ZERO_ONLY })
        return false // not OK, display error.
      }
      this.setState({ noExpenditureErrorMessage: NO_EXP_ERRMSG_MUTUALLY_EXCLUSIVE })
      return false // not OK, display error.
    }
    this.setState({ noExpenditureErrorMessage: '' })
    return true
  }

  getInitData(): {
        columns: Columns[],
        data: any,
        skipReset: boolean,
        model: MilestoneReportModel,
        modelPath: string,
        propertyName: string
        } {
    const { model } = this.props
    return {
      ...initialDataExpenditureMilestoneReport(model.eligibleExpenditureCategoryList),
      data: model.milestoneModel.eligibleExpenditureCategories,
      model,
      modelPath: 'milestoneModel.eligibleExpenditureCategories',
      propertyName: 'eligibleExpenditureCategories',
    }
  }

  getSelectedCategories(): string[] {
    const { model: { milestoneModel: { eligibleExpenditureCategories } } } = this.props

    return eligibleExpenditureCategories.map((f) => f.eligibleExpenditureCategoryCrmID)
  }

  // clear any displayed errors as soon as new-Row is added to table
  updateIsExpenditureTableEmptyToFalseHandler = () => {
    this.setState({
      isExpenditureTableEmpty: false,
      noExpenditureErrorMessage: '',
    })
  }

  rowRemovedHandler = (idx? : number) => {
    // clear NoExpenditure error whenever row removed.
    this.setState({
      noExpenditureErrorMessage: '',
    })
  }

  updateField = (change: Partial<any>, eligibleCategories: EligibleExpenditureCategoryMilestoneReportModel[], category: String) => {
    const { onChange, model } = this.props

    const isCategorySelected = this.isExpenseCategorySelected(eligibleCategories, category)
    delete change.field
    eligibleCategories[isCategorySelected.index] = { ...eligibleCategories[isCategorySelected.index], ...change }

    onChange({ eligibleExpenditureCategories: eligibleCategories })
  }

  onChange = (change: Partial<any>, callback?: { (): any }) => {
    const { onChange, model } = this.props

    const { eligibleExpenditureCategories } = model.milestoneModel
    // { ...model.milestoneModel.eligibleExpenditureCategories[0], ...change }

    if (change.hasOwnProperty('field')) {
      switch (change.field) {
        case EligibleExpenditureCategory.Consultant:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.Consultant)
          break

        case EligibleExpenditureCategory.OverseasRep:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.OverseasRep)
          break

        case EligibleExpenditureCategory.ShortTripsForeign:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.ShortTripsForeign)
          break

        case EligibleExpenditureCategory.ShortTripsAustralia:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.ShortTripsAustralia)
          break

        case EligibleExpenditureCategory.SolicitingBusinessForeign:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.SolicitingBusinessForeign)
          break

        case EligibleExpenditureCategory.FreeSample:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.FreeSample)
          break

        case EligibleExpenditureCategory.PromotionAdvertisingMaterial:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.PromotionAdvertisingMaterial)
          break

        case EligibleExpenditureCategory.IntellectualPropertyRights:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.IntellectualPropertyRights)
          break

        case EligibleExpenditureCategory.Training:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.Training)
          break

        case EligibleExpenditureCategory.ForeignBuyerVisit:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.ForeignBuyerVisit)
          break

        case EligibleExpenditureCategory.ExportTraining:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.ExportTraining)
          break

        case EligibleExpenditureCategory.NoExpenditure:
          this.updateField(change, eligibleExpenditureCategories, EligibleExpenditureCategory.NoExpenditure)
          break

        default:
      }
    }
  }

  mapTierRequirements(selectedTierRequirements: boolean[]) {
    const { model } = this.props

    const requirements: TierRequirement[] = []
    selectedTierRequirements.forEach((isSelected, i) => {
      if (isSelected) {
        requirements.push({
          milestoneReportID: model.milestoneModel.milestoneReportID,
          crmTierRequirementID: model.tierComplianceConfig[i].id,
          description: model.tierComplianceConfig[i].id === TierComplianceRequirements.OthersCrmId ? (this.tierComplianceComment ? this.tierComplianceComment.getValue() : '') : '',
        })
      }
    })
    return requirements
  }

  handleTierComplianceComment(comment: string) {
    const { onChange } = this.props

    const requirements = this.mapTierRequirements(this.state.tierRequirementsSelected)
    const index = requirements.findIndex((r) => r.crmTierRequirementID === TierComplianceRequirements.OthersCrmId)
    if (index > -1) {
      requirements[index].description = comment
      onChange({ tierRequirements: requirements })
      this.setState({ otherTierComplianceComment: comment })
    }
  }

  handleTierComplianceChanged(position: number, key: string) {
    const { model, onChange } = this.props

    let updatedCheckedState = this.state.tierRequirementsSelected.map((item, index) => (index === position ? !item : item))

    if (key === TierComplianceRequirements.OthersCrmId) {
      const isOtherTierCompliance = updatedCheckedState[position]
      this.setState({ isOtherTierCompliance })
      if (!isOtherTierCompliance) {
        // if other is unselected -> clear text
        this.tierComplianceComment.onChange('')
      }
    }

    if (key === TierComplianceRequirements.NotApplicableCrmId) {
      // uncheck all other options and clear comments
      updatedCheckedState = updatedCheckedState.map((v, i) => (i !== position ? false : v))
      const isOtherTierCompliance = false
      this.setState({ isOtherTierCompliance })
      if (!isOtherTierCompliance && this.tierComplianceComment) {
        // if other is unselected -> clear text
        this.tierComplianceComment.onChange('')
      }
    } else {
      // find & uncheck 'not applicable' option

      const notApplicable = model.tierComplianceConfig.map((d) => d.id).indexOf(TierComplianceRequirements.NotApplicableCrmId)
      if (notApplicable > -1) {
        updatedCheckedState[notApplicable] = false
      }
    }
    this.setState({ tierRequirementsSelected: updatedCheckedState })
    const requirements = this.mapTierRequirements(updatedCheckedState)
    onChange({ tierRequirements: requirements })
    // const isTierComplianceEmpty = !this.isTierComplianceOk()
    // this.setState({ isTierComplianceEmpty })
  }

  render() {
    const {
      loading, isExpenditureTableEmpty, noExpenditureErrorMessage, isTierComplianceEmpty,
    } = this.state
    const {
      model, onChange, history, preview,
    } = this.props

    const isOverseasSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.OverseasRep)
    const isConsultantSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.Consultant)
    const isShortTripForeigSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.ShortTripsForeign)
    const isShortTripAustraliaSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.ShortTripsAustralia)
    const isSolicitingForForeignCountrySelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.SolicitingBusinessForeign)
    const isFreeSamplesSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.FreeSample)
    const isPromotionalliteratureSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.PromotionAdvertisingMaterial)
    const isIntellectualPropertyRightsSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.IntellectualPropertyRights)
    const isTrainingSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.Training)
    const IsForeignBuyerSelected = this.isExpenseCategorySelected(model.milestoneModel.eligibleExpenditureCategories, EligibleExpenditureCategory.ForeignBuyerVisit)

    return (
      <>
        <h3>Activities and Expenditure</h3>

        <h3>Details of the Activities</h3>
        <div className="form-item">
          <MultiLineField
            ref={(r) => { this.promotionalActivityUndertaken = r }}
            id="promotionalActivityUndertaken "
            label={(
              <span>
                10. Summarise the promotional activities completed during the reporting period and how they have helped you achieve your goal(s) as per your plan to market or any new goals.
                <br />
                <br />
                (If you are a Representative Body only providing training to your members, briefly describe the training activities provided to your members and the number of participants).
                <br />
                <br />
                Please use a new line item/dot point for each high-level activity.
              </span>
)}
            value={model.milestoneModel.promotionalActivityUndertaken}
            onChange={(promotionalActivityUndertaken) => onChange({ promotionalActivityUndertaken })}
            maxLength={3000}
            required
            preview={preview}
          />
        </div>

        <h3>Compliance with requirements of your Tier</h3>
        <div className="form-item">

          <Label
            preview={preview}
            label={(
              <span>
                11. You must select from the below options how your export promotion activities have helped you achieve your tier requirements.
                <br />
                (Refer to your Grant Agreement and the EMDG Guidelines for Tier requirement details.) *
                <br />
                <br />
                You can select multiple options that relate to your Tier.
                <br />
                <br />
                You can only select 'Not Applicable' if you have not incurred eligible expenditure on export promotional activities for this reporting period.
              </span>
)}
          />
          {model.tierComplianceConfig.map((v, i) => (
            <Checkbox
              key={i}
              id={`tierCompliance-${i}`}
              required={false}
              onChange={() => this.handleTierComplianceChanged(i, v.id)}
              value={this.state.tierRequirementsSelected[i]}
              label={v.label}
              preview={preview}
              className={isTierComplianceEmpty ? 'checkbox-required' : ''}
            />
          ))}

          {this.state.isOtherTierCompliance
                        && (
                        <MultiLineField
                          ref={(r) => { this.tierComplianceComment = r }}
                          id="applicationCompletionImprovementComments"
                          label="11.a. If other, please describe."
                          value={this.state.otherTierComplianceComment}
                          onChange={(comment) => this.handleTierComplianceComment(comment)}
                          maxLength={4000}
                          rowNumber={6}
                          required={this.state.isOtherTierCompliance}
                          preview={preview}
                        />
                        )}
          <div tabIndex={-1} ref={(r) => { this.invalidTierComplianceError = r }}>
            <ErrorText text={isTierComplianceEmpty ? 'This field is required' : null} />
          </div>

          {/* {isTierComplianceEmpty && (
                        <div tabIndex={-1} ref={(r) => { this.invalidTierComplianceError = r }} className="mt-2">
                            <Alert className='emdg-page-alerts emdg-page-alerts--error'>
                                Please select at least one tier compliance.
                            </Alert>
                        </div>
                    )} */}
        </div>

        <h3>Complete the table against the Eligible Expenditure Categories</h3>

        <FormItem label={(
          <span className="form-content-preview" style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}>
            <Alert className="emdg-page-alerts">
              Complete the table for all eligible expenditure categories for which you are seeking a grant payment in this reporting period. All eligible expenditure should be GST exclusive.

              <br />
              <br />
              If you have not incurred eligible expenditure on export promotional activities for this reporting period, select "No expenditure" from the eligible expenditure category field and input zero (0) into all three columns.

              <br />
              <br />
              The Grantee must disclose only on 'eligible expenses' for 'eligible products' (as defined in the EMDG Act and Rules and Guidelines) in respect of:

              <ul>
                <li style={{ marginTop: '0px' }}>
                  promotional activities undertaken for the purposes of marketing an eligible product in a foreign country; and/or
                </li>
                <li style={{ marginTop: '0px' }}>
                  obtaining training for the purposes of developing the skills of the Grantee in marketing eligible products in foreign countries (only applies to Tier 1 and Representative Body).
                </li>
              </ul>

              <p>
                The Grantee must not seek grant funding to support on any excluded expenditure as defined in the EMDG Act or Rules.
                Specifically, expenses for promoting products that are subject to trade sanctions or that might have a detrimental impact on Australia's trade reputation are not eligible and must not be included.
              </p>

              <p>
                The 'amount of grant sought' and 'grantee's contribution amount' should equal the 'total eligible expenditure' for that category. The 'amount of grant sought' should be 50% or less than the 'grantee's contribution amount'.
              </p>

              <p>
                Please note the total grant sought cannot be greater than the maximum grant amount that is stated in your grant agreement for the reporting period.
                Your obligation is to match the dollar value of the grant monies you receive (this means you must spend double the grant amount), noting:
              </p>

              <br />
              <ul className="mt-0">
                <li style={{ marginTop: '0px' }}>
                  If you spend more, you will not receive more grant money. The amount in your grant agreement is the maximum you will receive.
                </li>
                <li style={{ marginTop: '0px' }}>
                  If you spend less, you will only receive an amount equal to the amount you contributed (i.e., if your grant agreement is for $15,000 and you spend $20,000 on eligible expenditure you will only receive $10,000).
                </li>
              </ul>

              <p>
                Apportionment
                <br />
                <br />
                Where only a portion of an expense is an 'eligible expense', such as travel expenses where a component of the trip relates to activities that are not part of the Activity, the Grantee must provide details of the apportionment and the basis upon which the apportionment has been made.
              </p>

              <p>
                For example: Your trip overseas may involve both promotional activities and personal or other business-related activities.
                If your records (such as diary entries, itineraries, etc) indicate that 30% of your trip was spent on promotional activities (for the purposes set out in your Grant Agreement), you apportion 30% of the trip costs to eligible marketing expenses.
              </p>
            </Alert>

          </span>
)}
        />

        <Label label="12. Please complete the table. *" preview={preview} />
        <MilestoneReportEditable
          ref={(r) => { this.editable = r }}
          onChange={onChange}
          initData={this.getInitData()}
          uniqueSelectSelection
          selectedCategories={this.getSelectedCategories()}
          rowAddedHandler={this.updateIsExpenditureTableEmptyToFalseHandler}
          rowRemovedHandler={this.rowRemovedHandler}
        />

        {/* misnomer: Table can be non-empty, but some cells are empty */}
        {isExpenditureTableEmpty && (
        <div tabIndex={-1} ref={(r) => { this.invalidExpenditureError = r }} className="mt-2">
          <Alert className="emdg-page-alerts emdg-page-alerts--error">
            Please complete the table. At least one expense category must be added. You can enter a zero amount.
          </Alert>
        </div>
        )}

        {noExpenditureErrorMessage && (
        <div tabIndex={-1} ref={(r) => { this.refInvalidNoExpensesRules = r }} className="mt-2">
          <Alert className="emdg-page-alerts emdg-page-alerts--error">
            {noExpenditureErrorMessage}
          </Alert>
        </div>
        )}

        <h3>Detailed description of the eligible expenses for the activity (for each expense category).</h3>
        <Label label="13. Provide a detailed description of the expenses for the selected expense category. *" preview={preview} />

        {isConsultantSelected.isPresent && (
        <EMDGAccordion expanded header="Consultants">
          <div className="form-item">
            <MultiLineField
              ref={(r) => { this.consultantsDescription = r }}
              id="ConsultantsDescription"
              label="Provide detailed description of the expenses."
              value={model.milestoneModel.eligibleExpenditureCategories[isConsultantSelected.index].expensesDescription}
              onChange={(expensesDescription) => this.onChange({ expensesDescription, field: 'Consultants' })}
              maxLength={3000}
              required={isConsultantSelected.isPresent}
              preview={preview}
            />

            <BooleanRadioButtonField
              ref={(r) => { this.canClaimConsultantCost = r }}
              id="canClaimConsultantCost"
              value={model.milestoneModel.canClaimConsultantCost}
              label="Was the cost of the consultant $60,000 or more?"
              onChange={(canClaimConsultantCost) => onChange({ canClaimConsultantCost })}
              dataSource={yesNoDataSource}
              required={isConsultantSelected.isPresent}

              preview={preview}
            />

            <Table<MilestoneConsultantModel>
              ref={(r) => { this.milestoneConsultants = r }}
              header={<Button id="btnAddMilestoneConsultant" className="emdg-btn prepare-btn" onClick={() => history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/expenditure/milestoneconsultant`)}>Add/Edit</Button>}
              label="Consultant"
              id="milestonecons"
              value={model.milestoneModel.milestoneConsultants}
              onChange={(milestoneConsultants) => onChange({ milestoneConsultants })}
              columns={MilestoneConsultantColumns}
              renderSection={(p) => <MilestoneConsultantDetails {...p} milestone={model.milestoneModel} addressCountries={model.markets} />}
              visible={model.milestoneModel.canClaimConsultantCost === true}
              required={isConsultantSelected.isPresent && model.milestoneModel.canClaimConsultantCost}

              allowEdit={false}
              alwaysShowAllRows
              preview={preview}
            />
          </div>
        </EMDGAccordion>

        )}

        {isOverseasSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Overseas Representatives">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.overseasDescription = r }}
                id="overseasDescription"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isOverseasSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.OverseasRep })}
                maxLength={3000}
                required={isOverseasSelected.isPresent}

                preview={preview}
              />

              <BooleanRadioButtonField
                ref={(r) => { this.canClaimOverseasRepresentativeCost = r }}
                id="canClaimOverseasRepresentativeCost"
                value={model.milestoneModel.canClaimOverseasRepresentativeCost}
                label="Was the cost of the overseas representative $60,000 or more?"
                onChange={(canClaimOverseasRepresentativeCost) => onChange({ canClaimOverseasRepresentativeCost })}
                dataSource={yesNoDataSource}
                required={isOverseasSelected.isPresent}

                preview={preview}
              />

              <Table<OverseasRepresentativeModel>
                ref={(r) => { this.overseasRepresentatives = r }}
                header={<Button id="btnAddOverseasReprentative" className="emdg-btn prepare-btn" onClick={() => history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/expenditure/overseasRepresentative`)}>Add/Edit</Button>}
                label="Overseas representatives"
                id="ovrseasrep"
                value={model.milestoneModel.overseasRepresentatives}
                onChange={(overseasRepresentatives) => onChange({ overseasRepresentatives })}
                columns={OverseasRepresentativeColumns}
                renderSection={(p) => <OverseasRepresentativeDetails {...p} milestone={model.milestoneModel} addressCountries={model.markets} />}
                visible={model.milestoneModel.canClaimOverseasRepresentativeCost === true}
                required={isOverseasSelected.isPresent && model.milestoneModel.canClaimOverseasRepresentativeCost}

                allowEdit={false}
                alwaysShowAllRows
                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        {isShortTripForeigSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Short trips to a foreign country">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.shortTripForeignCountry = r }}
                id="overseasDescription"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isShortTripForeigSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.ShortTripsForeign })}
                maxLength={3000}
                required={isShortTripForeigSelected.isPresent}

                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        {isShortTripAustraliaSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Short trips within Australia">

            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.shortTripAustralia = r }}
                id="shortTripAustralia"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isShortTripAustraliaSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.ShortTripsAustralia })}
                maxLength={3000}
                required={isShortTripAustraliaSelected.isPresent}

                preview={preview}
              />
            </div>

          </EMDGAccordion>
        </>
        )}

        {isSolicitingForForeignCountrySelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Soliciting for business in foreign country">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.solicitingForForeignCountry = r }}
                id="solicitingForForeignCountry"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isSolicitingForForeignCountrySelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.SolicitingBusinessForeign })}
                maxLength={3000}
                required={isSolicitingForForeignCountrySelected.isPresent}

                preview={preview}
              />
            </div>

          </EMDGAccordion>
        </>
        )}

        {isFreeSamplesSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Free samples">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.freeSamplesSelected = r }}
                id="freeSamples"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isFreeSamplesSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.FreeSample })}
                maxLength={3000}
                required={isFreeSamplesSelected.isPresent}

                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        {isIntellectualPropertyRightsSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Intellectual property rights">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.intellectualPropertyRights = r }}
                id="IntellectualProperty"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isIntellectualPropertyRightsSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.IntellectualPropertyRights })}
                maxLength={3000}
                required={isIntellectualPropertyRightsSelected.isPresent}

                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        {isPromotionalliteratureSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Promotional literature and advertising material">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.promotionalLiterature = r }}
                id="freeSamples"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isPromotionalliteratureSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.PromotionAdvertisingMaterial })}
                maxLength={3000}
                required={isPromotionalliteratureSelected.isPresent}

                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        {isTrainingSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Training">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.training = r }}
                id="taining"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[isTrainingSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.Training })}
                maxLength={3000}
                required={isTrainingSelected.isPresent}

                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        {IsForeignBuyerSelected.isPresent && (
        <>
          <br />
          <EMDGAccordion expanded header="Foreign buyer visits">
            <div className="form-item">
              <MultiLineField
                ref={(r) => { this.foreignBuyer = r }}
                id="foreignBuyer"
                label="Provide detailed description of the expenses."
                value={model.milestoneModel.eligibleExpenditureCategories[IsForeignBuyerSelected.index].expensesDescription}
                onChange={(expensesDescription) => this.onChange({ expensesDescription, field: EligibleExpenditureCategory.ForeignBuyerVisit })}
                maxLength={3000}
                required={IsForeignBuyerSelected.isPresent}
                preview={preview}
              />
            </div>
          </EMDGAccordion>
        </>
        )}

        <br />

        <NextBackButtons
          onBack={() => {
            if (confirm('Changes you made may not be saved.')) {
              history.goBack()
            }
          }}
          onNext={this.next}
        />
        <Backdrop on={loading} />
      </>
    )
  }
}
